import { UserFragmentFragment } from "../gql/graphql.ts";

export function isCompleteUser(
  user: UserFragmentFragment | undefined,
): boolean {
  return !!(user?.givenName && user?.familyName);
}
